export interface AggregationSum {
  key: string;
  value: number;
}

export interface Bucket {
  ts: string; // corresponds to "Date" field with JSON tag "ts"
  count: number;
  groups?: AggregationSum[];
}

export interface EventsHistogram {
  total: number;
  totalByGroup?: AggregationSum[];
  buckets: Bucket[];
}

// Reuse your Period from earlier
export enum Period {
  Day = 'day',
  Week = 'week',
  Month = 'month'
}

export const PeriodLabels = {
  [Period.Day]: 'Daily',
  [Period.Week]: 'Weekly',
  [Period.Month]: 'Monthly'
};

export const ALL_PERIODS: Period[] = [Period.Day, Period.Week, Period.Month];

export const DateRangeKey = 'dateRange';

export interface CalendarDateRange {
  from: Date;
  to: Date;
}

// --- Group By ---

// Human-facing labels for UI (types)
export enum EventsGroupByLabels {
  App = 'App',
  Task = 'Task',
  EventType = 'Event Type',
  EventsOrigin = 'Events origin',
  Offer = 'Offer',
  Deal = 'Deal',
  TaskType = 'Task Type'
}

// Machine values (API param)
export enum EventsGroupBy {
  App = 'apps',
  Task = 'tasks',
  EventsOrigin = 'subjectTypes',
  EventType = 'eventTypes',
  Offer = 'offers',
  Deal = 'deals',
  TaskType = 'plugins'
}

export const EventGroupByLabels = {
  [EventsGroupBy.App]: EventsGroupByLabels.App,
  [EventsGroupBy.EventType]: EventsGroupByLabels.EventType,
  [EventsGroupBy.Task]: EventsGroupByLabels.Task,
  [EventsGroupBy.EventsOrigin]: EventsGroupByLabels.EventsOrigin,
  [EventsGroupBy.Offer]: EventsGroupByLabels.Offer,
  [EventsGroupBy.Deal]: EventsGroupByLabels.Deal,
  [EventsGroupBy.TaskType]: EventsGroupByLabels.TaskType
};

export enum EventType {
  TaskListRequested = 'itemsListRequested',
  TaskRequested = 'itemRequested',
  TaskProcessStarted = 'itemProcessStarted',
  TaskClaimAttempt = 'itemClaimAttempt',
  TaskClaimSuccess = 'itemClaimSucceed',
  TaskClaimFailed = 'itemClaimFailed',
  TaskCompleted = 'itemCompleted',
  TaskActionRecorded = 'itemActionRecorded'
}

export const EventTypeLabels: Record<EventType, string> = {
  [EventType.TaskListRequested]: 'Task List Requested',
  [EventType.TaskRequested]: 'Task Requested',
  [EventType.TaskProcessStarted]: 'Process Started',
  [EventType.TaskClaimAttempt]: 'Claim Attempt',
  [EventType.TaskClaimSuccess]: 'Claim Success',
  [EventType.TaskClaimFailed]: 'Claim Failed',
  [EventType.TaskCompleted]: 'Task Completed',
  [EventType.TaskActionRecorded]: 'Action Recorded'
};

export enum SubjectType {
  Task = 'task',
  Offer = 'offer'
}

export const SubjectTypeLabels: Record<SubjectType, string> = {
  [SubjectType.Task]: 'Internal Tasks',
  [SubjectType.Offer]: 'External Deals'
};
